import WireCuttingAlarmModal from './wire_cutting_alarm-modal.vue'
export default WireCuttingAlarmModal
